<div *ngIf="viewModel; else emptyState" class="sankey-chart">
    <div class="sankey-columns">
        <div class="sankey-column" *ngFor="let stage of viewModel.stages; let i = index"
            (click)="onStageClick(i)"
            (keydown.enter)="onStageClick(i)"
            (keydown.space)="$event.preventDefault(); onStageClick(i)"
            role="button"
            tabindex="0"
            [attr.aria-label]="'Filtrar por ' + stage.label">
            <span class="stage-label">{{ stage.label }}</span>
            <p class="stage-count mb-0">
                <strong>{{ stage.count }}</strong> colaboradores
            </p>
            <span class="stage-percent">{{ stage.percentOfTotal }}% do total</span>
        </div>
    </div>

    <div class="sankey-chart-wrapper">
        <svg
            class="sankey-svg"
            [attr.viewBox]="'0 0 ' + viewModel.chartWidth + ' ' + viewModel.chartHeight"
            preserveAspectRatio="none"
            aria-hidden="true">
            <defs>
                <linearGradient
                    *ngFor="let gradient of flowGradients"
                    [attr.id]="gradient.id"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="0%">
                    <stop [attr.offset]="'0%'" [attr.stop-color]="gradient.from" stop-opacity="0.28" />
                    <stop [attr.offset]="'100%'" [attr.stop-color]="gradient.to" stop-opacity="0.28" />
                </linearGradient>
            </defs>

            <line
                *ngFor="let dividerX of viewModel.dividerPositions"
                class="sankey-divider"
                [attr.x1]="dividerX"
                [attr.y1]="0"
                [attr.x2]="dividerX"
                [attr.y2]="viewModel.chartHeight"
            />

            <path
                *ngFor="let flow of viewModel.flows"
                [attr.d]="flow.path"
                [attr.fill]="'url(#' + flow.gradientId + ')'"
            />

            <ng-container *ngFor="let stage of viewModel.stages; let i = index">
                <rect
                    *ngIf="stage.barHeight > 0"
                    class="sankey-bar"
                    [class.sankey-bar--active]="isStageActive(stage)"
                    [class.sankey-bar--dimmed]="isStageDimmed(stage)"
                    [attr.x]="stage.barX"
                    [attr.y]="stage.barY"
                    [attr.width]="viewModel.barWidth"
                    [attr.height]="stage.barHeight"
                    [attr.fill]="stage.barColor"
                    role="button"
                    tabindex="0"
                    [attr.aria-label]="'Filtrar por ' + stage.label"
                    (click)="onStageClick(i); $event.stopPropagation()"
                    (keydown.enter)="onStageClick(i); $event.stopPropagation()"
                    (keydown.space)="$event.preventDefault(); onStageClick(i); $event.stopPropagation()"
                    rx="3"
                />
            </ng-container>
        </svg>
    </div>
</div>

<ng-template #emptyState>
    <p class="text-muted text-center py-5 mb-0">{{ emptyMessage }}</p>
</ng-template>
